import { SelectAction, SelectState } from './types';

export const initialState: SelectState = {
  active: false,
  activeOption: -1,
  inputActive: false,
  query: '',
  showMenu: false,
};

export const reducer = (
  state: SelectState,
  action: SelectAction,
): SelectState => {
  switch (action.type) {
    case 'OUTSIDE_CLICK':
      return {
        ...state,
        active: false,
        activeOption: -1,
        inputActive: false,
        query: '',
        showMenu: false,
      };
    case 'SELECT_ITEM_AND_CLOSE_LISTBOX':
      return {
        ...state,
        activeOption: -1,
        inputActive: false,
        query: '',
        showMenu: false,
      };
    case 'CLOST_LISTBOX_AND_UNSET_QUERY_INPUT':
      return {
        ...state,
        activeOption: -1,
        inputActive: false,
        query: '',
        showMenu: false,
      };
    case 'SHOW_MENU_AND_ACTIVE_OPTION':
      return {
        ...state,
        ...action.payload,
        showMenu: true,
      };
    case 'SET_ACTIVE_OPTION':
      return {
        ...state,
        ...action.payload,
      };
    case 'SET_ACTIVE':
      return {
        ...state,
        ...action.payload,
      };
    case 'OPEN_LISTBOX_AND_ACTIVATE_QUERY_INPUT':
      return {
        ...state,
        ...action.payload,
        active: true,
        query: '',
        showMenu: !state.showMenu,
      };
    case 'UPDATE_QUERY':
      return {
        ...state,
        ...action.payload,
        activeOption: action.payload?.query?.length ? 0 : -1,
      };
    case 'OPTION_SELECTED':
      return {
        ...state,
        inputActive: false,
        query: '',
        showMenu: false,
      };
    case 'CLOSE_SEARCHABLE_LISTBOX':
      return {
        ...state,
        inputActive: false,
        query: '',
        showMenu: false,
      };
    default:
      throw new Error('Unknown Action');
  }
};
